export function getPaginationPage(page: number | string): number {
  const actual = Number(page)

  if (typeof page === 'string') return actual
  if (Number.isNaN(actual)) return 0
  return page
}
